<template>
    <!-- 测试须知 -->
    <section class="container">
        <Header></Header>
        <div class="wrapper">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>学习指南</BreadcrumbItem>
                    <BreadcrumbItem>测试须知</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    测试须知
                </div>
                <div class="inner-wrapper" v-html="content">
                </div>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "TestRequest",
        data(){
            return {
                content: ''
            }
        },
        mounted(){
            this.getInstance();
          this.setTab();
        },
        methods: {
            getInstance(){
                var that = this;
                this.$http({
                    url: that.webhost + 'guide/getContent/4',
                    method: 'GET'
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.content = data.data;
                    }
                })
            }
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 90px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .locationM{
        height: 50px;
        line-height: 50px;
    }
    .locationM .ivu-breadcrumb{
        font-size: 15px;
        color: #000;
    }
    .locationM img{
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }
    .inner-wrapper{
        padding: 20px 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/TestRequest.vue